export default "__VITE_ASSET__DGrYoFLD__"